import React from 'react';
import HTML from '@sp/ui/base/HTML';
import { openLink } from 'helpers/linking';

const HTMLContainer = (props) => <HTML onLinkPress={(_, url) => openLink(url)} {...props} />;

export default HTMLContainer;
